<template>
  <div>
    <button class="btn btn-info mb-2" @click.prevent="openModal">
      <i class="fas fa-plus"></i>Add
      <!-- Thêm -->
    </button>
    <b-table
      bordered
      head-variant="dark"
      hover
      responsive
      :fields="fields"
      :items="items"
      table-variant="light"
    >
      <template v-slot:cell(action)="data">
         <b-link class="text-primary mr-2" href="#" @click.prevent="openUpdateModal(data)">
          <i class="fas fa-pencil-alt"></i>
        </b-link>
        <b-link class="text-danger" href="#" @click.prevent="deleteData(data)">
          <i class="fas fa-trash"></i>
        </b-link>
      </template>
    </b-table>

    <b-modal
      v-model="modalShow"
      header-bg-variant="info"
      header-text-variant="light"
      @hidden="closeModal"
      hide-footer
    >
      <template v-slot:modal-title>
        <div v-if="item.id <= 0">Add information
          <!-- Thêm thông tin -->
        </div>
        <div v-else>
          Update information
          <!-- Cập nhật thông tin thưởng dự án -->
        </div>
      </template>
      <b-form class="mr-4" autocomplete="off" @submit.prevent="storeData">
        <b-form-row class="mb-4">
          <b-col cols="3">
            <label class="mr-2">Condition
              <!-- Điều kiện -->
            </label>
          </b-col>
          <b-col cols="6">
            <b-form-input v-model="item.condition" type="number" step="any"></b-form-input>
          </b-col>
          <b-col cols="3">
            <b-button class="mr-3" variant="info" type="submit">
              <i class="fas fa-save mr-2"></i>Save
              <!-- Lưu -->
            </b-button>
          </b-col>
        </b-form-row>
        <b-form-row class="mb-4">
          <b-col cols="3">
            <label class="mr-2">Amount
              <!-- Tiền -->
            </label>
            <code>*</code>
          </b-col>
          <b-col cols="3">
            <b-form-input v-model="money_selected" type="number" step="any"></b-form-input>
          </b-col>
          <b-col cols="3">
            <label class="mr-2">Type
              <!-- Loại -->
            </label>
            <code>*</code>
          </b-col>
          <b-col cols="3">
            <b-form-select v-model="type_selected" :options="optionsType" value-field="value" text-field="text"></b-form-select>
          </b-col>
        </b-form-row>
      </b-form>
    </b-modal>
  </div>
</template>

<script>

export default {
  name: "HopDongLaoDongThuongTruongDuan",
  props: ["hopdong"],
  data() {
    return {
      fields: [
        {
          key: "condition",
          label: "Condition"
          // label: "Điều kiện"
        },
        {
          key: "vnd",
          label: "VND"
        },
        {
          key: "tien",
          label: "USD"
        },
        {
          key: "rate",
          label: "Rate"
        },
        {
          key: "action",
          label: "",
          tdClass: "text-center",
          thClass: "align-middle",
          thStyle: { width: "75px !important", textAlign: "center" },
        },
      ],
      item_null: {
        id: 0,
        employeecontractid: 0,
        employeecontractbonusid: 0,
        condition: 0.0,
        tien: 0.0,
        vnd: 0.0,
        rate: 0.0,
      },
      item: {
        id: 0,
        employeecontractid: 0,
        employeecontractbonusid: 0,
        condition: 0.0,
        tien: 0.0,
        vnd: 0.0,
        rate: 0.0,
      },
      optionsType: [{value: 0, text: "VND"}, {value: 1, text: "USD"}, {value: 2, text: "Rate"}],
      items: [],
      modalShow: false,
      money_selected: 0,
      type_selected: 0,
      itemIndex: 0,
    }
  },
  created() {
    if (this.hopdong != null) this.initData();
  },
  methods: {
    initData() {
      if (this.hopdong.employeeContractBonusPMs) {
        this.items = JSON.parse(JSON.stringify(this.hopdong.employeeContractBonusPMs));
      }
    },

    openModal() {
      this.item = JSON.parse(JSON.stringify(this.item_null));
      this.modalShow = true;
    },
    openUpdateModal(data) {
      this.item = JSON.parse(JSON.stringify(data.item));
      this.itemIdex = data.index;
      if (this.item.vnd) {this.money_selected = this.item.vnd; this.type_selected = 0;}
      if (this.item.tien) {this.money_selected = this.item.tien; this.type_selected = 1;}
      if (this.item.rate) {this.money_selected = this.item.rate; this.type_selected = 2;}
      this.modalShow = true;
    },
    closeModal() {
      this.modalShow = false;
      this.type_selected = 0;
      this.money_selected = 0;
    },
    storeData() {
      if (this.type_selected == 0) this.item.vnd = parseFloat(this.money_selected);
      if (this.type_selected == 1) this.item.tien = parseFloat(this.money_selected);
      if (this.type_selected == 2) this.item.rate = parseFloat(this.money_selected);

      this.item.condition = parseFloat(this.item.condition);
      this.item.employeecontractid = this.hopdong.id;
      this.item.employeecontractbonusid = this.hopdong.employeeContractBonuses.find(x => x.vitricongviec == this.$project_manager).id;
      this.items.push(this.item);
      this.closeModal();
    },
    updateData() {
      this.items[this.itemIdex] = this.item;
      this.items = JSON.parse(JSON.stringify(this.items));
      this.modalShow = false;
    },
    deleteData(data) {
      this.$toast.question("Bạn có thực sự muốn xóa không?", "Nhắc nhở", {
        timeout: 20000,
        close: false,
        overlay: true,
        displayMode: "once",
        position: "center",
        buttons: [
          [
            "<button><b>Có</b></button>",
            (instance, toast) => {
              this.items.splice(data.index, 1);
              instance.hide({ transitionOut: "fadeOut" }, toast, "button");
            },
            true,
          ],
          [
            "<button>Không</button>",
            function (instance, toast) {
              instance.hide({ transitionOut: "fadeOut" }, toast, "button");
            },
          ],
        ],
      });
    },
  }
}
</script>